"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _reactInputMask = _interopRequireWildcard(require("../../../vendors/react-input-mask"));
var _utils = require("../../utils");
var _ = require("../");
var _constants = require("./constants");
var _propTypes = require("./propTypes");
var _react2 = require("@emotion/react");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const MaskedInput = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    mask,
    maskPlaceholder = _constants.DEFAULT_MASK_PLACEHOLDER,
    onChange,
    shouldAlwaysShowMask = false,
    value,
    ...forwardedProps
  } = _ref;
  if (forwardedProps.disabled) {
    return (0, _react2.jsx)(_.Input, (0, _extends2.default)({}, forwardedProps, {
      ref: ref,
      value: value
    }));
  }
  const inputProps = (0, _utils.omit)(forwardedProps, _reactInputMask.inputMaskControlledProps);
  const maskProps = (0, _utils.pick)(forwardedProps, _reactInputMask.inputMaskControlledProps);
  const maskUtils = new _reactInputMask.MaskUtils({
    mask,
    maskPlaceholder
  });
  const handleOnChange = e => {
    const targetValue = e.target.value;
    if (onChange) {
      onChange(e, maskUtils.formatValue(targetValue), targetValue.replace(/[^a-zA-Z\d\u00C0-\u00FF]+/g, ''));
    }
  };
  return (0, _react2.jsx)(_reactInputMask.default, (0, _extends2.default)({}, maskProps, {
    alwaysShowMask: shouldAlwaysShowMask,
    mask: mask,
    maskPlaceholder: maskPlaceholder,
    onChange: handleOnChange,
    value: value
  }), (0, _react2.jsx)(_.Input, (0, _extends2.default)({}, inputProps, {
    ref: ref
  })));
});
var _default = exports.default = (0, _utils.composeStencilComponent)({
  baseComponent: MaskedInput,
  description: 'Input element that automatically formats text according to a mask.',
  displayName: 'MaskedInput',
  propTypes: _propTypes.maskedInputPropTypes
});